import React from 'react';
import { useFormikContext } from 'formik';
import { FormGroup } from '../../form';
import { InputText } from '../../formikBindings';

const VisitorLoginForm: React.FC = () => {
  const { isSubmitting } = useFormikContext();

  return (
    <FormGroup name="pin" label="PIN">
      <InputText name="pin" disabled={isSubmitting} autoFocus />
    </FormGroup>
  );
};

export default VisitorLoginForm;
